import { Routes } from '@angular/router';

import { HomePageComponent } from './home-page.component';
import { HomeResolver } from './home.resolver';

export const HOME_PAGE_ROUTES: Routes = [
  {
    path: '',
    component: HomePageComponent,
    pathMatch: 'full',
    resolve: { home: HomeResolver },
    data: { breadcrumb: 'home' },
  },
];
